import { Injectable } from "@angular/core";
import * as _ from "lodash";

@Injectable({
    providedIn: "root"
})
export class LocalStoreService {
    static store(data: any) {
        if (data) {
          const dataObjStr = sessionStorage.getItem("base");
          let dataObj = dataObjStr ? JSON.parse(dataObjStr) : null;
          if (!dataObj) {
            dataObj = {
              cardLastNumber: null,
              ownerName: null,
              cardPhoneNumber: null
            };
          }
          dataObj = Object.assign(dataObj, data);
          localStorage.setItem("base", window.btoa(JSON.stringify(dataObj)));
        }
    }

    static get(): any {
      const val = localStorage.getItem("base");
      return (_.isString(val) && !_.isEmpty(val)) ? JSON.parse(window.atob(val)) : null;
    }

    static storeSessionWarningTime(time): void {
      localStorage.setItem("sessionwarningtime", time);
    }

    static getSessionWarningTime(): number {
      const time = localStorage.getItem("sessionwarningtime");
      return (_.isString(time) && !_.isEmpty(time)) ? parseInt(time, 0) : -1;
    }

    static storeSessionTimeOut(time): void {
      localStorage.setItem("sessiontimeout", time);
    }

    static getSessionTimeOut(): number {
      const time = localStorage.getItem("sessiontimeout");
      return (_.isString(time) && !_.isEmpty(time)) ? parseInt(time, 0) : -1;
    }

    static clearSessionTime(): void {
      localStorage.removeItem("sessionwarningtime");
      localStorage.removeItem("sessiontimeout");
    }

    static clear() {
      localStorage.removeItem("base");
    }
}
